<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
/*import vsconsole from 'vconsole';*/
// import {buriedPoint} from '@/api/common'

export default {
  mounted(){
    // this.buriedPointPv()
  },
  created(){

  /*  if(process.env.VUE_APP_ENV_SERVER_TYPE  !== 'production') new vsconsole();*/
  },
  methods:{
    // h5的访问数埋点
    // buriedPointPv(){
    //   buriedPoint({code:'H5PAGE'}).then(()=>{})
    // }
  }

}
</script>

<style>
#app {
  max-width: 10rem;
  margin:  0 auto;
  font-size: 14px;
  letter-spacing: 1px;
  height: 100%;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
